import { Component, Input } from '@angular/core';
import { AuthService } from 'src/app/core/auth/auth.service';
import { USER_ROLES } from 'src/app/core/services/api.service';
import { UserProxy } from 'src/app/core/store/user/user.proxy';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'main-menu',
  templateUrl: 'main-menu.component.html',
  styleUrls: ['main-menu.component.scss'],
})
export class MainMenuComponent {
  basePath: string = 'dashboard';
  @Input() isMobile = false;
  @Input() isOnboarding = false;
  @Input() isBlocked = false;

  USER_ROLES = USER_ROLES;
  skillsValidation = environment.skillsValidation;
  role$ = this.userProxy.currentRole$;
  
  messageCount$ = this.userProxy.messageCount$;
  notifyCount$ = this.userProxy.notifyCount$;
  appliesCount$ = this.userProxy.appliesCount$;

  constructor(private userProxy: UserProxy, private authService: AuthService) {
    this.userProxy.currentRole$.subscribe(role => console.log("ROLE:", role))
  }

  private currentRole: string = null;

  ngOnInit(): void {
    this.role$.subscribe(role => {
      this.currentRole = role;
      if (role === USER_ROLES.talent) {
        this.basePath = 'talent';
      } else if (role === USER_ROLES.hm) {
        this.basePath = 'hm';
      } else {
        this.basePath = 'dashboard';
      }
    });
  }

  getDashboardLink(): string {
    if (this.currentRole === USER_ROLES.admin)  return '/dashboard/bi';
    if (this.currentRole === USER_ROLES.talent) return '/talent';
    if (this.currentRole === USER_ROLES.hm) return '/hm/recruiter';
    if (this.currentRole === USER_ROLES.accountAdmin) return '/dashboard/recruiter';
    return '/dashboard/recruiter';
  }


  logout() {
    this.authService.logout();
  }

}
